import React, { useState } from 'react';

const ChevronDown = () => (
  <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor"
    strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const ChevronRight = () => (
  <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor"
    strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const HierarchyIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="6" cy="18" r="2.5" />
    <circle cx="6" cy="6" r="2.5" />
    <circle cx="18" cy="18" r="2.5" />
    <path d="M6 8.5v5" />
    <path d="M8.5 18h7" />
    <path d="M6 13.5a4.5 4.5 0 0 1 4.5 4.5" />
  </svg>
);

const TreeNode = ({ node, level = 0, onSelect, selectedName }) => {
  const [isOpen, setIsOpen] = useState(level < 2); // top 2 levels open by default

  const isSelected = selectedName === node.name;

  const handleClick = () => {
    if (node.isGroup) {
      setIsOpen((prev) => !prev);
    }
    if (onSelect) onSelect(node);
  };

  return (
    <div className="flex flex-col select-none">
      <div
        onClick={handleClick}
        className={`
          flex items-center py-[3px] cursor-pointer transition-colors duration-100 rounded-sm
          ${isSelected ? 'bg-[#d6e4f7]' : 'hover:bg-[#EAF0FC]'}
        `}
        style={{ paddingLeft: `${level * 14 + 4}px` }}
      >
        {/* Toggle icon — only for groups */}
        <span className="w-4 flex justify-center items-center shrink-0 text-[#213CA5]">
          {node.isGroup
            ? isOpen ? <ChevronDown /> : <ChevronRight />
            : null
          }
        </span>

        {/* Node label */}
        <span
          className={`
            text-[12px] uppercase tracking-wide truncate leading-5
            ${node.isGroup
              ? 'text-[#213CA5] font-bold'
              : 'text-[#5A7DC0] font-medium pl-1'
            }
          `}
        >
          {node.name}
        </span>
      </div>

      {node.isGroup && isOpen && node.children?.length > 0 && (
        <div>
          {node.children.map((child, index) => (
            <TreeNode
              key={`${child.name}-${index}`}
              node={child}
              level={level + 1}
              onSelect={onSelect}
              selectedName={selectedName}
            />
          ))}
        </div>
      )}
    </div>
  );
};

function AccountHierarchyTree({ treeData, onSelect, selectedName }) {
  return (
    <div className="w-full h-full bg-[#EAF0FC] flex flex-col overflow-hidden">
      
      {/* ── Header ─────────────────────────────────────────────── */}
      <div className="flex-shrink-0 px-3 py-5">
        <div className="flex items-center text-[#334155] font-bold text-[14px]">
          <HierarchyIcon size={16} />
          <span className="ml-2">Account Structure</span>
        </div>
      </div>

      {/* ── Tree Card ──────────────────────────────────────────── */}
      <div className="flex-1 overflow-hidden min-h-0 flex flex-col mx-3 mb-1 
                      bg-white border border-[#D1E0F5] rounded-lg shadow-sm">
        
        {/* Card header — fixed height */}
        <div className="flex-shrink-0 bg-[#213CA5] text-white flex items-center px-3 py-2">
          <HierarchyIcon size={14} />
          <span className="ml-2 text-[12px] font-semibold tracking-wide">Account Groups</span>
        </div>

        <div className="flex-1 overflow-y-auto min-h-0 p-2 tree-scrollbar">
          {treeData && treeData.map((node, index) => (
            <TreeNode
              key={`${node.name}-${index}`}
              node={node}
              level={0}
              onSelect={onSelect}
              selectedName={selectedName}
            />
          ))}
        </div>

      </div>

      <style>{`
        .tree-scrollbar::-webkit-scrollbar { width: 5px; }
        .tree-scrollbar::-webkit-scrollbar-track { background: #f1f5f9; }
        .tree-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        .tree-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
      `}</style>

    </div>
  );
}

export default AccountHierarchyTree;